<sb-dashboard-widget [isLoading]="isLoading()" [title]="'Worked vs. scheduled hours' | translate" [fixedHeight]="false">
  @if (chart()) {
    <sb-chart [type]="chart().type" [data]="chart().data" [options]="chart().options" [height]="height()"></sb-chart>
  }
</sb-dashboard-widget>
